import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";

class ModalButton extends Component {
  render() {
    const {
      action,
      openModal,
      label,
      resourceName,
      forceShow,
      editModal,
      resource,
    } = this.props;

    console.warn(resource);

    if (forceShow || action === "edit") {
      return (
        <Button
          variant="link"
          size="sm"
          onClick={() => {
            resource
              ? editModal(resourceName, resource)
              : openModal(resourceName);
          }}
        >
          {label}
        </Button>
      );
    }

    return null;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    action: state.ui.action,
    forceShow: ownProps.forceShow ? ownProps.forceShow : false,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    openModal: (resourceName) =>
      dispatch({ type: "OPEN_RESOURCE_MODAL", payload: { resourceName } }),
    editModal: (resourceName, resource) =>
      dispatch({
        type: "EDIT_RESOURCE",
        payload: { resourceName, resource },
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalButton);
